export function isServerCheck() {
  return typeof window === 'undefined';
}
